<template>
    <div class="log-index">
        <div class="left">
            <p class="fontdark font16 fontbig mt-24 ml-24">日志管理</p>
            <div class="line"></div>
            <div
                class="fontcursor"
                v-for="(item, index) in menuList"
                :key="index"
                :class="['left-menu-item', { ['left-menu-item-active']: activeMenu == item.path }]"
                @click="link(item.path)"
            >
                {{ item.displayName }}
            </div>
        </div>
        <div class="right">
            <div class="top">
                <Breadcrumb class="bread">
                    <BreadcrumbItem :to="item.to" v-for="item in bread" :key="item.title">{{item.title}}</BreadcrumbItem>
                </Breadcrumb>
            </div>
            <div class="content">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                bread: [
                    {}
                ],
                menuList: [
                    {
                        displayName: "操作日志",
                        frontendCode: "service_my_service",
                        id: 10002,
                        parentId: 10001,
                        path: "/operation-log",
                    },
                    {
                        displayName: "调用日志",
                        frontendCode: "service_my_apply",
                        id: 10003,
                        parentId: 10001,
                        path: "/call-log",
                    },
                ],
                activeMenu: ""
            }
        },
        watch: {
            $route: {
                handler() {
                    this.activeMenu = this.$route.meta.towActive;
                    this.bread = this.$route.meta.bread;
                    console.log(this.$route.meta.bread)
                },
                immediate: true
            }
        },
        methods: {
            link(path) {
                // this.activeMenu = path;
                this.$router.push(path)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .log-index {
        height: 100%;
        display: flex;
        .left {
            width: 190px;
            height: 100%;
            background: #ffffff;
            flex-shrink: 0;
            .line {
                width: 142px;
                height: 1px;
                background: #ebedf0;
                margin: 24px auto 16px;
            }
            .left-menu-item {
            width: 100%;
            height: 38px;
            padding-left: 24px;
            display: flex;
            align-items: center;
            color: #67799c;
            }
            .left-menu-item-active {
            color: #3c8aff;
            background: rgba(60, 138, 255, 0.05);
            }
        }
        .right {
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            padding: 0px 24px 24px;
            overflow-x: hidden;
            .top {
                flex-shrink: 0;
                display: flex;
                .bread {
                    color: #2f4061;
                    margin: 24px 0;
                }
            }
            .content {
                flex-grow: 1;
                background-color: #fff;
                border-radius: 6px;
                overflow: hidden;
            }
        }
    }
</style>
